// extracted by mini-css-extract-plugin
module.exports = {"headerArea":"AdministrationHeader_headerArea__3Th1p","headerLabel":"AdministrationHeader_headerLabel__2EevH"};